import { instance } from './config';

export const getSales = () => {
   return instance.get('/sale');
};

export const getSalesById = (requestId) => {
   return instance.get('/sale/id/' + requestId);
};

export const getSalesByDate = (startDate, endDate, pageNumber) => {
   return instance.get('/sale/dates', {
      params: {
         startDate: startDate,
         endDate: endDate,
         pageNumber: pageNumber,
      },
   });
};

export const getSalesByTransactionId = (transactionId) => {
   return instance.get(`/sale/transaction/${transactionId}`);
};

export const getSalesByDateAndMeter = (startDate, endDate, meterNumber) => {
   return instance.get('/sale/dates_meter', {
      params: {
         startDate: startDate,
         endDate: endDate,
         meterNumber: meterNumber,
      },
   });
};

export const getSalesByDatesCriteria = (startDate, endDate, keySearch, keyValue) => {
   return instance.get('/sale/dates_criteria', {
      params: {
         startDate: startDate,
         endDate: endDate,
         keySearch: keySearch,
         keyValue: keyValue,
      },
   });
};

export const getSaleStatsByStatus = (startDate, endDate) => {
   return instance.get('/sale/dates_criteria', {
      params: {
         startDate: startDate,
         endDate: endDate,
      },
   });
};

export const getSalesReport = (requestData) => {
   return instance.post('/sale/report', requestData);
};
